<template>
  <section id="js-scroll" class="not-cooperation">
    <h2 class="sub-title">
      {{ NotCooperation.title[lang] }}
    </h2>
    <p class="oauth-description">
      {{ NotCooperation.about[lang] }}
    </p>
    <p class="margin-top25">
      {{ NotCooperation.description[lang] }}&nbsp;{{ eventName }}
    </p>
    <figure class="app-overview">
      <img
        src="../../../assets/images/app/runkeeper-app-logo.png"
        alt=""
        width="40px"
        height="40px"
      />
      <figcaption class="app-name">ASICS Runkeeper™</figcaption>
    </figure>
    <p class="margin-top25" v-html="NotCooperation.attention[lang]"> </p>
    <div class="cooperation-button">
      <PrimaryButton type="button" @click.native="runkeeperAuth">
        {{ NotCooperation.cooperation[lang] }}
      </PrimaryButton>
    </div>
  </section>
</template>

<script>
import PrimaryButton from "./PrimaryButton";
import NotCooperation from "../../../assets/constants/confirmation/not-cooperation/not-cooperation";
export default {
  data() {
    return {
      NotCooperation: NotCooperation,
    };
  },
  mounted() {
    // 要素見えない可能性あるのでスクロール入れる
    const element = document.getElementById("js-scroll");
    element.scrollIntoView({ behavior: "smooth" });
  },
  props: {
    email: {
      type: String,
    },
    appauthid: {
      type: String,
    },
    lang: {
      type: String,
    },
    eventName: {
      type: String,
    },
  },
  methods: {
    runkeeperAuth: function () {
      const oauthUrl = process.env.RUNKEEPER.OAUTH_URI;
      const clientId = process.env.RUNKEEPER.CLIENT_ID;
      const resType = process.env.RUNKEEPER.RES_TYPE;
      const redirectUrl = process.env.SITE.TMF_REDIRECT_URL;
      location.href = `${oauthUrl}?client_id=${clientId}&response_type=${resType}&redirect_uri=${redirectUrl}?lang=${this.lang}`;
    },
  },
  components: {
    PrimaryButton,
  },
  name: "NotCooperation",
};
</script>

<style scoped>
.not-cooperation {
  .sub-title {
    font-size: 30px;
    text-align: center;
  }

  .oauth-description {
    margin: 45px 0 0 0;
  }

  .app-overview {
    display: flex;
    align-items: center;
    margin: 45px 0 0 0;

    .app-name {
      margin: 0 0 0 10px;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .cooperation-button {
    margin: 12px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/oauth/NotCooperation.vue